import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PhoneFormatPipe} from '../misc/pipes/phone-format/phone-format.pipe';
import {CurrencyFormatPipe} from '../misc/pipes/currency-format/currency-format.pipe';
import {DiscountedPricePipe} from '../misc/pipes/discounted-price/discounted-price.pipe';

export const COMMON_IMPORTS = [
	RouterModule,
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	NgOptimizedImage,
	PhoneFormatPipe,
	CurrencyFormatPipe,
	DiscountedPricePipe
] as const;
